export default {
  className: 'kingKongDistrict',
  fields: [
    {
      name: 'name',
      validators: [
        (val) => val ? null : '名称不可为空'
      ]
    },
    {
      name: 'orderIndex',
      validators: [
        (val) => val ? null : '排序不可为空',
        (val) => {
          if (val && val % 1 !== 0) {
            return '排序必须为数字且为整数'
          }
        },
        (val) => val < 0 ? '排序必须为正整数' : null
      ]
    },
    {
      name: 'functionType',
      validators: [
        (val) => val ? null : '功能类型不可为空'
      ]
    },
    {
      name: 'image',
      tooltip: '尺寸1 : 1，建议98px * 98px',
      validators: [
        (val) => val ? null : '图品不可为空'
      ]
    }
  ],
  search: [
    'name',
    'functionType'
  ],
  action: {
    create: false,
    delete: false
  }
}
